import dynamic from 'next/dynamic';

import { HotelGalleryPhotoViewerComponentProps } from './HotelGalleryPhotoViewer.types';

export const HotelGalleryPhotoViewerMGP = dynamic<HotelGalleryPhotoViewerComponentProps>(() =>
  import('./HotelGalleryPhotoViewerComponent').then(module => module.HotelGalleryPhotoViewerComponent)
);
